import React from "react";

export const UnitCustomIdInput = ({customUnitId, displayName, onChange}) => {

  const handleCustomUnitIdChange = (event) => {
    onChange(event.target.value);
  }

  return (<div className="flex-1">
    <label className="block text-xs font-medium text-gray-700 mb-1">
      Einheit-ID (opt.)
    </label>
    <input
        type="text"
        placeholder={displayName}
        value={customUnitId}
        onChange={handleCustomUnitIdChange}
        className="w-full text-sm px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500"
    />
  </div>);
};